import { useEffect } from "react";
import { X } from "lucide-react";

export default function SlideOverPanel({ open, title, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose && onClose();
    };
    if (open) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <>
      {/* Backdrop */}
      <div
        data-testid="panel-backdrop"
        onClick={onClose}
        className={`fixed inset-0 z-[80] bg-black/40 transition-opacity duration-[900ms] ease-out ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />

      {/* Panel */}
      <aside
        data-testid="slide-panel"
        aria-hidden={!open}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        className={`fixed top-0 right-0 z-[90] h-screen w-[92%] sm:w-[70%] md:w-[58%] lg:w-[46%] xl:w-[42%] bg-[#F4EBDD] shadow-[0_0_60px_rgba(0,0,0,0.18)] transform transition-transform ease-[cubic-bezier(0.16,1,0.3,1)] cursor-default ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ transitionDuration: "1300ms" }}
      >
        <div className="flex items-center justify-end px-6 sm:px-12 md:px-16 py-6">
          <button
            data-testid="panel-close"
            onClick={onClose}
            aria-label="Close panel"
            className="p-2 text-[#76232F] hover:bg-[#76232F] hover:text-[#F4EBDD] transition-colors border border-transparent hover:border-[#76232F] cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div
          className="h-[calc(100vh-73px)] overflow-y-auto px-6 sm:px-12 md:px-16 pt-2 md:pt-3 pb-12 md:pb-16"
          data-testid="panel-content"
        >
          {children}
        </div>
      </aside>
    </>
  );
}
